import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import throttle from 'lodash/throttle'
import Sticky from 'react-stickynode'
import {
  LAZY_LOAD_SCROLL_OFFSET,
  BREAKPOINT_EXTRA_SMALL,
  CX,
} from '../constants'
import { me, showSuggestedUsers } from '../initial_state'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import TabBar from '../components/tab_bar'
import WelcomeReminders from '../components/welcome_reminders'
import HomeCallToAction from '../components/home_call_to_action'
import Announcement from '../components/announcement'
import HomeSortBlock from '../components/home_sort_block'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import {
  LinkFooter,
  UserSuggestionsPanel,
  ProPanel,
  ShopPanel,
  ProgressPanel,
  GabAdTopPanel,
  GabAdBottomPanel,
  BusinessesPanel,
  BusinessListingsPanel,
} from '../features/ui/util/async_components'
import { supportsPassiveEvents } from 'detect-it'
import ComposeForm from '../features/compose/components/compose_form'
import ShortcutsAvatarList from '../components/shortcuts_avatar_list'
import ForYouTimeline from '../features/for_you_timeline'
import { timelineClear } from '../store/timelines'
import TabBarItem from '../components/tab_bar_item'

let homeTimelineSavedPref = localStorage.getItem('home_timeline_saved_preference') || 'for-you';

class HomePage extends React.PureComponent {

  state = {
    lazyLoaded: false,
    timeline: homeTimelineSavedPref,
    top: 0,
    stickied: false,
  }

  componentDidMount() {
    this.window = window
    if (top != self) top.location.replace(location)

    this.documentElement = document.scrollingElement || document.documentElement

    this.window.addEventListener('scroll', this.handleScroll, supportsPassiveEvents ? { passive: true } : false)
  }

  componentWillUnmount() {
    this.window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const { width } = this.props
    const isXS = width <= BREAKPOINT_EXTRA_SMALL

    if (this.window && isXS) {
      const navbarEl = document.getElementById('nav-container')
      let isStickied = navbarEl ? navbarEl.getAttribute('data-stickied') === '1' : null
      let theTop = navbarEl ? navbarEl.getAttribute('data-ty') : null
      let theBottom = navbarEl ? navbarEl.getBoundingClientRect().bottom : null

      // alert(isStickied)

      if (!isNaN(theBottom) && theBottom !== 0 && theBottom !== 53 && !isStickied) {
        theBottom = `${Math.max(theBottom, 0)}px`
        this.setState({ top: theBottom })
      } else {
        this.setState({ top: '53px' })
      }
    }
  }

  onStickyStateChange = (status) => {
    if (status.status === Sticky.STATUS_FIXED) {
      this.setState({ stickied: true })
    } else {
      this.setState({ stickied: false })
    }
  }

  handleOnChangeTimeline = (timeline) => {
    window.scrollTo(0, 0)
    if (this.state.timeline === timeline) return
    
    if (timeline === 'for-you') this.props.onClearForYouTimeline()
    this.setState({ timeline })
    localStorage.setItem('home_timeline_saved_preference', timeline)
    homeTimelineSavedPref = timeline;
  }

  render() {
    const {
      children,
      isPro,
      notificationCount,
      unreadChatsCount,
      unreadWarningsCount,
      width,
    } = this.props
    const {
      lazyLoaded,
      timeline,
      top: theTop,
      stickied
    } = this.state

    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    const isSlim = width >= 1305
    const title = "Home"
    const sidebarLayout = [
      <WrappedBundle key='home-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'home.sidebar', position: 1 }} />,
      ProgressPanel,
      <WrappedBundle key='home-page-pro-panel' component={ProPanel} componentParams={{ isPro: isPro }} />,
      BusinessesPanel,
      BusinessListingsPanel,
      <WrappedBundle key='home-page-shop-panel' component={ShopPanel} componentParams={{ isLazy: true, shouldLoad: lazyLoaded }} />,
      showSuggestedUsers && <WrappedBundle key='home-page-user-suggestions-panel' component={UserSuggestionsPanel} componentParams={{ isLazy: true, type: 'related', shouldLoad: lazyLoaded }} />,
      LinkFooter,
      <WrappedBundle key='home-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'home.sidebar', position: 1 }} />,
    ].filter(Boolean)

    const actions = !isXS ? [] : [
      {
        icon: 'ai-robot',
        href: 'https://gab.ai',
      },
      {
        icon: 'search',
        to: '/search/top',
      },
      {
        icon: 'chat',
        to: '/messages',
        count: unreadChatsCount,
      }
    ]

    const shouldHaveSpace = `${theTop}` === '0' || `${theTop}` === '0px'
    const tabBarContainerClasses = CX({
      d: 1,
      w100PC: 1,
      minH53PX: !isXS,
      radiusSmall: !isXS && !stickied,
      // topLeftRadiusSmall:
      // topRightRadiusSmall:
      // bottomRightRadiusSmall:
      // bottomLeftRadiusSmall:
      overflowHidden: 1,
      border1PX: !isXS,
      borderBottom1PX: isXS,
      borderColorSecondary: 1,
      bgPrimary: 1,
      mb15: 1,
      // posSticky: 1,
      // top53PX: !isXS,
      z6: 1,
      saveAreaInsetPT: isXS && stickied,
      saveAreaInsetPL: isXS && stickied,
      saveAreaInsetPR: isXS && stickied,
      // transitionTransform025: 1,
    })

    const foryouTimelineWrapperClasses = CX({
      d: 1,
      w100PC: 1,
      mt15: isXS,
    })

    return (
      <DefaultLayout
        slimLayout={isSlim}
        page='home'
        title={title}
        actions={actions}
        layout={sidebarLayout}
      >

        <PageTitle
          path={title}
          badge={notificationCount}
        />

        {
          !isNaN(unreadWarningsCount) && unreadWarningsCount > 0 &&
          <Announcement
            title={`You have ${unreadWarningsCount} new account notice${unreadWarningsCount > 1 ? 's' : '' }`}
            actionTitle='Click to view'
            actionTo='/warnings'
          />
        }
        
        <div className={[_s.d, _s.z6, _s.minH53PX, _s.w100PC].join(' ')}>
          <Sticky top={isXS ? 0 : 53} enabled onStateChange={this.onStickyStateChange}>
            <div className={tabBarContainerClasses}>
              <div className={[_s.d, _s.h53PX, _s.px5, _s.flexRow, _s.overflowXScroll, _s.noScrollbar].join(' ')}>
                <TabBarItem
                  isLarge
                  shouldGrow
                  onClick={() => this.handleOnChangeTimeline('for-you')}
                  title='For you'
                  isActive={timeline === 'for-you'}
                />
                <TabBarItem
                  isLarge
                  shouldGrow
                  onClick={() => this.handleOnChangeTimeline('following')}
                  title='Following'
                  isActive={timeline !== 'for-you'}
                />
              </div>
            </div>
          </Sticky>
        </div>

        <ComposeForm isSlim composerId="home-timeline" />

        {isXS && <ShortcutsAvatarList />}

        <WelcomeReminders />

        <HomeCallToAction isXS={isXS} />

        {
          timeline !== 'for-you' &&
          <div className={isXS ? [_s.d, _s.pl10, _s.pt15].join(' ') : _s.d}>
            <HomeSortBlock />
          </div>
        }

        {timeline !== 'for-you' && children}
        {
          timeline === 'for-you' && 
          <div className={foryouTimelineWrapperClasses}>
            <ForYouTimeline />
          </div>
        }

      </DefaultLayout>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  onClearForYouTimeline() {
    dispatch(timelineClear('for-you'))
  },
})

const mapStateToProps = (state) => ({
  notificationCount: state.getIn(['notifications', 'unread']),
  unreadChatsCount: state.getIn(['chats', 'chatsUnreadCount'], 0),
  unreadWarningsCount: state.getIn(['warnings', 'unreadCount'], 0),
  isPro: state.getIn(['accounts', me, 'is_pro']),
  width: state.getIn(['settings', 'window_dimensions', 'width']),
})

HomePage.propTypes = {
  children: PropTypes.node.isRequired,
  isPro: PropTypes.bool,
  unreadChatsCount: PropTypes.number.isRequired,
  unreadWarningsCount: PropTypes.number.isRequired,
  notificationCount: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)
